import React, { type HTMLAttributes } from 'react';
import { cn } from '@/app/_lib/utils';

export interface BlockquoteProps extends HTMLAttributes<HTMLQuoteElement> {
  children: React.ReactNode;
  className?: string;
}

/**
 * Blockquote component for quoted content.
 * Based on Figma specs: border-l-2, pl-6, italic
 */
export function Blockquote({ children, className, ...props }: BlockquoteProps) {
  return (
    <blockquote
      className={cn('flex flex-col gap-2 border-l-2 pl-6 mb-6 [&>*:last-child]:mb-0', className)}
      {...props}
    >
      {children}
    </blockquote>
  );
}
